// Runtime configuration loader
let config: { REACT_APP_API_URL?: string } | null = null;
let configLoaded = false;

export const loadConfig = async (): Promise<void> => {
  if (configLoaded) return;
  
  try {
    const response = await fetch('/config.json?t=' + Date.now());
    if (response.ok) {
      config = await response.json();
      console.log('Runtime config loaded:', config);
      configLoaded = true;
    } else {
      console.warn('Config.json not found, using build-time environment variables');
      configLoaded = true;
    }
  } catch (error) {
    console.warn('Failed to load runtime config, using build-time defaults', error);
    configLoaded = true;
  }
};

export const getApiUrl = (): string => {
  // Try runtime config first, then build-time env, then fallback
  const url = config?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    'http://localhost:5000/api';
  
  console.log('Using API URL:', url);
  return url;
};
